'use client'

import { MC, SANS } from '@/lib/mycio/theme'
import { LANDING_CSS } from '@/components/mycio/marketing/landing/styles'
import Nav from '@/components/mycio/marketing/landing/Nav'
import MarketingFooter from '@/components/mycio/marketing/landing/MarketingFooter'
import { useMyCIOLanguage } from '@/lib/mycio/MyCIOLanguageContext'
import { isMyCIORtlLanguage } from '@/lib/mycio/translations'
import { coverageT } from '@/lib/mycio/coverageI18n'

/**
 * Page chrome for the public coverage pages: the landing's top bar, tokens, responsive tiers and footer, so
 * the country pages and the landing read as one product.
 *
 * TRANSLATED BY MACHINE, ONCE (founder, 2026-09-20: "why don't we do auto translation so we do not need to
 * pre-translate?"). The pages follow the site's language selector like every other page; the words come from
 * coverage.i18n.generated.json, produced by scripts/translate_coverage.py with the product's own OpenAI key
 * and committed. A browser's translate bar was the first answer and the wrong one: it never follows the
 * selector, and it only appears when the browser's language differs from the page's. In any language but
 * English the shell says the page is machine-translated and names the English page as the reference —
 * these are tax-coverage claims, and the reader should know which text is the one we stand behind.
 */
export default function CoverageShell({ children }: { children: React.ReactNode }) {
  const { language } = useMyCIOLanguage()
  const t = coverageT(language)
  const rtl = isMyCIORtlLanguage(language)
  return (
    <div className="lp" style={{ fontFamily: SANS, color: MC.ink, background: MC.bg, minHeight: '100vh', WebkitFontSmoothing: 'antialiased' }}>
      <style>{LANDING_CSS}</style>
      <Nav />
      {t.machine && (
        <div role="note" style={{ background: MC.sageBg, borderBottom: `1px solid ${MC.mist}` }}>
          <p style={{ maxWidth: 1180, margin: '0 auto', padding: '10px 32px', fontSize: 13.5, lineHeight: 1.5, color: MC.forestDeep }}>{t.ui('machineTranslated')}</p>
        </div>
      )}
      <main lang={language} dir={rtl ? 'rtl' : 'ltr'}>{children}</main>
      <MarketingFooter />
    </div>
  )
}
